import _ from 'lodash';
import { JSEncrypt } from 'jsencrypt'
import {URL_API_USER_DATA, URL_API_USER_DATA_ADD, URL_API_USER_DATA_EDIT, URL_API_LOGIN, URL_API_USER_DATA_STATUS_EDIT,URL_API_TOKEN_VALIDATION,
  URL_API_USER_DATA_CATEGORIES, URL_API_USER_DATA_SUPERVISORS, URL_API_USER_DATA_ROLES, URL_API_USER_DATA_MAPPED_INVENTORY} from '../apiHitFile';
import {LoginActionSuccess} from '../Login/LoginActions'
export function UserAction(obj) {  
  
  return (dispatch, getState)  => {
    dispatch(UserDataPending());
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_USER_DATA,{
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then(res=>res.json())
      .then(json => {
        if(json.status === 403){
          dispatch(showModalLogin())   
        } else {
          dispatch(UserDataSuceess(json))
        }
      })
      .catch(error => {
          dispatch(UserDataError(error))
    })
  }
}
export function UserDataPending(){
  return {
      type: "USER_ACTION_PENDING",
      isPending:true
  }
}

export function UserDataSuceess(data){
  if(data.status === 1001){   
  return {
      type: "USER_ACTION",
      result: data.value, 
      isPending:false    
    }
  }
  else{
    return {
      type: "USER_ACTION_EDIT_ERROR",
      errmessage:data.message,
      showerror:true,
      isPending:false,
    }
  }  
}

export function UserDataError(error){
  return {
      type: "USER_ACTION_EDIT_ERROR",
      errmessage: error.message,
      showerror:true,
      isPending:false
  }
}
export function UserActionAdd(newData){  
  return (dispatch, getState) => {
  dispatch(UserDataPending());
  const currentToken = getState().LoginReducer.session;  
  let headers = new Headers()
  headers.append("Authorization",currentToken);  
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  fetch(URL_API_USER_DATA_ADD, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(newData)
  }).then((res) => res.json())
    .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(UserAddSuccess(json))
        dispatch(UserEditError(json))
      }
    })
    .catch(error => {
        dispatch(UserEditError(error))
    })
  }
}  

export function UserAddSuccess(newData){  
  if(newData.status === 1001 && !_.isEmpty(newData.value)){  
  return{
    type: 'USER_ACTION_ADD',
    newData: newData.value, 
    isPending:false
   }
  } else {
    return {
      type: "USER_ACTION_EDIT_ERROR",
      errmessage: newData.message,
      showerror:true,
      isPending:false
    }
  }    
}
export function UserActionEdit(newData){  
  return (dispatch, getState)  => {
  dispatch(UserDataPending());
  const currentToken = getState().LoginReducer.session;  
  let headers = new Headers()
  headers.append("Authorization",currentToken);  
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  fetch(URL_API_USER_DATA_EDIT, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(newData)
  }).then((res) => res.json())
    .then(json => {
        if(json.status === 403){
          dispatch(showModalLogin())   
        } else {
          dispatch(UserEditSuccess(newData))
          dispatch(UserEditError(json))
        }
      })
    .catch(error => {
        dispatch(UserEditError(error))
    })
  }
}
export function UserEditSuccess(newData){  
  return{
    type: 'USER_ACTION_EDIT',
    newData:newData,
    isPending:false
   }
}
export function UserEditError(error){   
  return{
    type: 'USER_ACTION_EDIT_ERROR',
    errmessage: error.message,
    showerror:true,
    isPending:false  
   } 
}
export function UserStatusEdit(Obj){  
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_USER_DATA_STATUS_EDIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(Obj)
    }).then((res) => res.json())
    .then((data) =>{        
      if(data.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(UserEditError(data))
       dispatch(UserStatusSuccess(Obj)) 
      }
    })
    .catch(error => {
        dispatch(UserEditError(error))
    })
    }
}
export function UserStatusSuccess(Obj){
  return{
    type: 'USER_STATUS',
    StatusWise: Obj
  } 
}
export function DashboardAction(prop){
  return{
    type: 'DASHBOARD_LENGTH',
    size: prop
  } 
}
export function Category() {
  let obj = {'inventoryType':'CATEGORY'}
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization", currentToken);    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_USER_DATA_CATEGORIES,{
      method: 'POST',
      headers : headers,
      body: JSON.stringify(obj)
    }).then(res=>res.json())
     .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(CategorySuceess(json))
      }
      })
     .catch(error => {})    
  }
}
export function CategorySuceess(category){
  if(category.status === 1001 && !_.isEmpty(category.value)){ 
  return{
    type:"USER_ACTION_CATEGORY",
    category:category.value
    }
  } 
}
export function Superviosor() {
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    fetch(URL_API_USER_DATA_SUPERVISORS,{
      method: 'POST',
      headers: headers
    })
     .then(res=>res.json())
     .then(json =>{
      if(json.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(SuperviosorSuceess(json))
      }
     }) 
     .catch(error => {
        console.log(error)
    })
    }
}
export function SuperviosorSuceess (supervisor){
  if(supervisor.status === 1001 && !_.isEmpty(supervisor.value)){ 
  return{
    type:"USER_ACTION_SUPERVISOR",
    supervisor:supervisor.value
  }
 } 
}
export function RoleAction() {
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    fetch(URL_API_USER_DATA_ROLES, {
      method: 'POST',
      headers: headers
    })
     .then(res=>res.json())
     .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(RoleActionSuceess(json))
      } })
     .catch(error => {
        console.log(error)
     })
    }
}
export function RoleActionSuceess(roles) {  
  if(roles.status === 1001 && !_.isEmpty(roles.value)){ 
  return{
    type:"USER_ACTION_ROLES",
    roles:roles.value
  }
 }
}
export function closeModalPopUp(){
  return{
    type:'USER_ACTION_MODAL_CLOSE',
    showerror:false
  }

}

export function InventoryUserMappedAction() {
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append("Authorization",currentToken);
    fetch(URL_API_USER_DATA_MAPPED_INVENTORY, {
      method: 'POST',
      headers: headers
    })
     .then(res=>res.json())
     .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())   
      } else {
        dispatch(InventoryUserMappedActionSuccess(json))
      } })
     .catch(error => {
        console.log(error)
    })
  // .catch(error => dispatch(InventoryUserMappedActionSuccess(inventoryMapped)))
     
    }
}
export function InventoryUserMappedActionSuccess(data) {  
  if(data.status === 1001 && !_.isEmpty(data.value)){ 
  return{
    type:"USER_ACTION_MAPPED_INVENTORY",
    inventoryMapped:data.value
  }
 }
}

export function TokenValidation(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    let obj = {"token": currentToken }
    fetch(URL_API_TOKEN_VALIDATION, {
      method: 'POST',
      headers: headers,
      body:JSON.stringify(obj)
    })
     .then(res=>res.json())
     .then((json) =>{
       if(json.status === 1001 && !_.isEmpty(json.value)){
        console.log('success')
       } else {         
         dispatch(showModalLogin())
       }
    })
     .catch((error) =>{
      dispatch(showModalLogin(error))
    })
  }
}

export function ReLogin(id, password){
  const publickey = process.env.REACT_APP_PUBLIC_KEY;
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publickey);
  const encyPassword = encrypt.encrypt(password);
  let obj = {'username': id , 'password': encyPassword}
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return dispatch => {
    fetch(URL_API_LOGIN, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{
        if(json.status === 1001 && !_.isEmpty(json.value)){  
          dispatch(LoginActionSuccess(json))
          dispatch(makeShowmodalFalse())  
        } else {
          alert(json.message)
        }   
        })
      .catch((error) =>{
        alert(error.message)     
      })
  }
}
export function showModalLogin(){
  return{
    type:"SHOW_LOGIN_MODAL",
    showModalLogin:true,
  }

}
export function makeShowmodalFalse(){
  return{
    type:"SHOW_LOGIN_MODAL_FALSE",
    showModalLogin:false
  }
}


